module.exports = __webpack_public_path__ + "images/emoji/green_heart.1a0713ea753dbd60e446.png";